import React, { useState, useEffect, useContext } from 'react'
import Swal from 'sweetalert2';
import { deleteNotificationById, getNotifications, putNotificationStatus } from '../api/notifications';
import { AuthContext } from '../context/AuthContext';

export const useNotification = () => {
  const { setLoading,checkToken } = useContext(AuthContext);
  const [notifications, setNotifications] = useState([]);

  const getNotification = async (status, page=1,loading=true) => {
    checkToken()
    try {

      setLoading(loading)
      const { data } = await getNotifications(status, page);
      setLoading(false)
      setNotifications(data.data);
      return [true,data.data]
    } catch (e) {
      setLoading(false)
      setNotifications([]);
      return [false]
    }
  }

  const deleteNotification = async (id) => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await deleteNotificationById(id);
      setNotifications([...notifications, data.data]);
      setLoading(false);
      return (true)
    }
    catch (e) {
      setLoading(false);
      //console.log(e.response?._response);
      return (false)
    }
  }

  const updateNotificationStatus = async (id, data) => {
    checkToken()
    try {
      setLoading(true);
      const resp = await putNotificationStatus(id, data);
      setLoading(false);
      console.log("resp",resp)
      return (true)
    }
    catch (e) {
      setLoading(false);
      console.log("ERROR");
      return (false)
    }
  }

  return {
    notifications,
    getNotification,
    deleteNotification,
    updateNotificationStatus
  }
}